<template>
  <div class="header" v-cloak>
    <div class="header_box">
      <div style="display: inline-block">
        <img
          src="../assets/img/login/logo.png"
          @click.stop="toIndex"
          alt
          class="headerLogo"
        />
      </div>
      <div class="userName">
        <div class="homeBox" @click.stop="gohome">
          <svg-icon iconClass="homeIcon" class="homeIcon"></svg-icon>
          <span class="headerSize" v-if="activeIndex == 0" style="color:#ec9368"
            >首页</span
          >
          <span class="headerSize" v-else>首页</span>
        </div>
        <div class="spacer"></div>
        <div @click.stop="gotoshoppingCart" class="homeBox">
          <svg-icon iconClass="gouwuche" class="gouwuche"></svg-icon>
          <span class="headerSize" v-if="activeIndex == 1" style="color:#ec9368"
            >购物车</span
          >
          <span class="headerSize" v-else>购物车</span>
        </div>
        <div class="spacer"></div>
        <div @click.stop="gotoCommodityOrder" class="homeBox">
          <svg-icon iconClass="myOrder" class="myOrder"></svg-icon>
          <span class="headerSize" v-if="activeIndex == 2" style="color:#ec9368"
            >我的订单</span
          >
          <span class="headerSize" v-else>我的订单</span>
        </div>
        <template v-if="showAnalysis">
          <div class="spacer"></div>
          <div @click.stop="gotoAnalysis" class="homeBox">
            <svg-icon iconClass="myOrder" class="myOrder"></svg-icon>
            <span
              class="headerSize"
              v-if="activeIndex == 3"
              style="color:#ec9368"
            >
              数据分析
            </span>
            <span class="headerSize" v-else>数据分析</span>
          </div>
        </template>

        <div class="spacer"></div>

        <div style="position: relative;">
          <div @click.stop="setout" class="homeBox">
            <svg-icon iconClass="wode" class="wode"></svg-icon>
            <span
              class="headerSize"
              v-if="activeIndex == 4"
              style="color:#ec9368"
              >信息中心</span
            >
            <span class="headerSize" v-else>信息中心</span>
          </div>
          <div class="header_wode">
            <div
              class="user_zhanghu"
              v-if="userData.username"
              @click="upshowCondition"
            >
              {{ userData.username }}
            </div>
            <div
              class="user_Out"
              @click.stop="goCollection('收藏')"
              @mouseenter="enter('收藏')"
              @mouseleave="leave('收藏')"
            >
              <svg-icon
                iconClass="collection_default"
                v-if="!collection"
                className="collection_default"
              ></svg-icon>
              <svg-icon
                v-if="collection"
                iconClass="collection_selected"
                className="collection_default"
              ></svg-icon
              >我的收藏
            </div>
            <div
              class="user_Out"
              v-if="userData.position == 'zlfAdmin'"
              @mouseenter="enter('账号管理')"
              @mouseleave="leave('账号管理')"
              @click.stop="goCollection('账号管理')"
            >
              <svg-icon
                iconClass="changepassword-selected"
                v-if="accountmanagement"
                className="collection_default"
              ></svg-icon>
              <svg-icon
                iconClass="changepassword-default"
                v-if="!accountmanagement"
                className="collection_default"
              ></svg-icon
              >账号管理
            </div>
            <div
              class="user_Out"
              v-if="userData.position == 'zlfAdmin'"
              @mouseenter="enter('组织机构')"
              @mouseleave="leave('组织机构')"
              @click.stop="goCollection('组织机构')"
            >
              <svg-icon
                iconClass="organization-selected"
                v-if="organization"
                className="collection_default"
              ></svg-icon>
              <svg-icon
                iconClass="organization-default"
                v-if="!organization"
                className="collection_default"
              ></svg-icon
              >组织机构
            </div>
            <div
              class="user_Out"
              v-if="userData.position == 'zlfAdmin'"
              @mouseenter="enter('日志管理')"
              @mouseleave="leave('日志管理')"
              @click.stop="goCollection('日志管理')"
            >
              <svg-icon
                iconClass="logmanagement-selected"
                v-if="logmanagement"
                className="collection_default"
              ></svg-icon>
              <svg-icon
                iconClass="logmanagement-default"
                v-if="!logmanagement"
                className="collection_default"
              ></svg-icon
              >日志管理
            </div>
            <div
              class="user_Out"
              @mouseenter="enter('修改密码')"
              @mouseleave="leave('修改密码')"
              @click.stop="goCollection('修改密码')"
            >
              <svg-icon
                iconClass="footprint_selected"
                v-if="changepassword"
                className="collection_default"
              ></svg-icon>
              <svg-icon
                iconClass="footprint_default"
                v-if="!changepassword"
                className="collection_default"
              ></svg-icon
              >修改密码
            </div>
            <div
              class="user_Out"
              @mouseenter="enter('退出')"
              @mouseleave="leave('退出')"
              @click.stop="loginOut"
            >
              <svg-icon
                iconClass="logmanagement-selected"
                v-if="logout"
                className="collection_default"
              ></svg-icon>
              <svg-icon
                iconClass="logmanagement-default"
                v-if="!logout"
                className="collection_default"
              ></svg-icon
              >退出
            </div>
          </div>
        </div>

        <div class="shadow" @click="upshowCondition"></div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery'
import ls from '@/utils/localStorage'
export default {
  data() {
    return {
      userName: true,
      userData: ls.get('userData'),
      logout: false,
      collection: false,
      footprint: false,
      accountmanagement: false,
      organization: false,
      logmanagement: false,
      changepassword: false,
      activeIndex: 9,
      showAnalysis: false,
    }
  },
  mounted() {
    if (!ls.get('userData')) {
      this.$store.dispatch('LogOut').then(() => {
        this.$router.replace('/login')
      })
    }

    setTimeout(() => {
      const userData = ls.get('userData')
      this.showAnalysis =
        userData?.roleDesc && userData?.roleDesc.includes('ex-data-analysis')
    }, 500)
  },
  activated() {},
  methods: {
    // 跳转收藏或者足迹
    goCollection(text) {
      if (text === '收藏') {
        this.$router.push({ path: '/collection' })
      } else if (text === '足迹') {
        this.$router.push({ path: '/footprint' })
      } else if (text === '修改密码') {
        this.$router.push({ path: '/changepassword' })
      }
      document.body.style.overflow = 'auto'
      this.upshowCondition()
    },
    enter(e) {
      if (e == '收藏') {
        this.collection = true
      } else if (e == '足迹') {
        this.footprint = true
      } else if (e == '退出') {
        this.logout = true
      } else if (e == '账号管理') {
        this.accountmanagement = true
      } else if (e == '日志管理') {
        this.logmanagement = true
      } else if (e == '修改密码') {
        this.changepassword = true
      } else if (e == '组织机构') {
        this.organization = true
      }
    },
    leave(e) {
      if (e == '收藏') {
        this.collection = false
      } else if (e == '足迹') {
        this.footprint = false
      } else if (e == '退出') {
        this.logout = false
      } else if (e == '账号管理') {
        this.accountmanagement = false
      } else if (e == '日志管理') {
        this.logmanagement = false
      } else if (e == '修改密码') {
        this.changepassword = false
      } else if (e == '组织机构') {
        this.organization = false
      }
    },
    toIndex() {
      $('.shadow').css('display', 'none')
      $('.header_wode').css('display', 'none')
      this.$router.push({ path: '/home' })
    },
    // 前往购物车
    gotoshoppingCart() {
      $('.shadow').css('display', 'none')
      $('.header_wode').css('display', 'none')
      this.$router.push({ path: '/shoppingCart' })
      localStorage.setItem('title', '')
      localStorage.setItem('val', '')
      this.activeIndex = 1
    },
    // 前往订单页
    gotoCommodityOrder() {
      $('.shadow').css('display', 'none')
      $('.header_wode').css('display', 'none')
      this.$router.push({ path: './CommodityOrder' })
      localStorage.setItem('title', '')
      localStorage.setItem('val', '')
      this.activeIndex = 2
    },

    // 前往数据分析
    gotoAnalysis() {
      $('.shadow').css('display', 'none')
      $('.header_wode').css('display', 'none')
      this.$router.push({ path: './analysis' })
      localStorage.setItem('title', '')
      localStorage.setItem('val', '')
      this.activeIndex = 3
    },

    // 前往首页
    gohome() {
      $('.shadow').css('display', 'none')
      $('.header_wode').css('display', 'none')
      this.$router.replace({ path: '/home' })
      localStorage.setItem('title', '')
      localStorage.setItem('val', '')
      this.activeIndex = 0
    },
    // 退出登录
    loginOut() {
      document.body.style.overflow = 'auto'
      this.$store.dispatch('LogOut').then(() => {
        ls.set('isAgreement', false)
        this.$router.replace('/login')
      })
    },
    setout() {
      $('.shadow').css('display', 'block')
      $('.header_wode').css('display', 'block')
      $('.header_wode').animate({ top: '28px' })
      document.body.style.overflow = 'hidden'
      this.activeIndex = 4
    },
    // 关闭弹窗
    upshowCondition() {
      $('.header_wode').animate({ top: '-400px' })
      // $(".header_wode").css("display", "none");
      $('.shadow').css('display', 'none')
      document.body.style.overflow = 'auto'
      // this.userName = false
    },
    userNamedata() {
      this.userName = true
    },
  },
}
</script>

<style scoped>
[v-cloak] {
  display: none;
}
.user_Out:last-child {
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  border-bottom: none;
}
.user_Out {
  cursor: pointer;
  width: 100%;
  height: 42px;
  border-bottom: 1px solid #f3f3f3;
  font-size: 18px;
  color: #000;
  background-color: #fff;
  text-align: center;
  line-height: 42px;
}
.collection_default {
  width: 20px;
  height: 20px;
  margin-right: 5px;
}
.user_zhanghu {
  width: 100%;
  height: 52px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  text-align: center;
  font-size: 18px;
  color: #ec9368;
  background-color: #fdf2ec;
  border-radius: 5px;
  line-height: 52px;
}
.box_header_wode {
  width: 274px;
  height: 94px;
}
.header_wode {
  width: 274px;
  height: 180px;
  /* position: relative; */
  position: absolute;
  z-index: 2001;
  right: -93px;
  top: -208px;
  display: none;
  border-radius: 5px;
  background-color: #fff;
}
/* // 遮罩层 */
.shadow {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 2000;
  background-color: #000;
  opacity: 0.6;
  display: none;
}
.header_box {
  display: flex;
  justify-content: space-between;
  width: 1500px;
  margin: 0 auto;
  align-items: center;
}
.wode {
  cursor: pointer;
  width: 22px;
  height: 22px;
}
.gouwuche {
  cursor: pointer;
  width: 22px;
  height: 22px;
  margin-right: 3px;
}
.myOrder {
  cursor: pointer;
  /* right: 1px; */
  width: 22px;
  height: 22px;
  margin-right: 3px;
}
.homeIcon {
  cursor: pointer;
  width: 22px;
  height: 22px;
  margin-right: 3px;
}
.guide {
  width: 24px;
  height: 24px;
}
.headerSize {
  cursor: pointer;
  font-size: 18px;
  color: #000;
}
.headerLogo {
  height: 50px;
  display: inline-block;
  margin-left: 25px;
  padding-top: 10px;
  padding-bottom: 11px;
}
.city {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 2px;
  vertical-align: middle;
  border-top: 4px solid gray;
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;
}
.spacer {
  width: 2px;
  background: #ec9368;
  height: 18px;
  margin: 0 20px;
}
.userName {
  display: flex;
  font-size: 0;
  align-items: center;
}
.homeBox {
  display: flex;
  align-items: center;
}
.header {
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 80px;
  background: url(../assets/img/List/hera.png) no-repeat;
}
</style>
